module.exports = __webpack_public_path__ + "img/SAMAR.e362db71.png";